import React from 'react';
import classes from './Pagination.module.scss';

const Pagination = ({ totalPosts, postsPerPage, currentPage, setCurrentPage }) => {
  const totalPages = Math.ceil(totalPosts / postsPerPage);

  const pageNumbers: number[] = [];
  for (let i = 1; i <= totalPages; i++) {
    pageNumbers.push(i);
  }

  const renderPageNumbers = () => {
    const elements: JSX.Element[] = [];


    if (totalPages <= 1) {
      // 総ページ数が1ページ以下の場合、1ページ目のボタンのみを表示
      elements.push(
        <button
          className={classes.active}
          onClick={() => setCurrentPage(1)}
        >
          1
        </button>
      );
      return elements;
    }
    
    if (currentPage !== 1) {
      elements.push(<button onClick={() => setCurrentPage(currentPage - 1)}>＜</button>);
    }
    
    elements.push(
      <button
        className={currentPage === 1 ? classes.active : ''}
        onClick={() => setCurrentPage(1)}
      >
        1
      </button>
    );
    
    if (currentPage > 3) {
      elements.push(<span>…</span>);
    }
    
    for (let i = currentPage - 1; i <= currentPage + 1; i++) {
      if (i > 1 && i < totalPages) {
        elements.push(
          <button
            className={currentPage === i ? classes.active : ''}
            onClick={() => setCurrentPage(i)}
          >
            {i}
          </button>
        );
      }
    }

    if (currentPage < totalPages - 1) {
      elements.push(<span>…</span>);
    }

    elements.push(
      <button
        className={currentPage === totalPages ? classes.active : ''}
        onClick={() => setCurrentPage(totalPages)}
      >
        {totalPages}
      </button>
    );
    
    if (currentPage !== totalPages) {
      elements.push(<button onClick={() => setCurrentPage(currentPage + 1)}>＞</button>);
    }

    return elements;
  }

  return (
    <div className={classes.pagination}>
      {renderPageNumbers()}
    </div>
  );
};

export default Pagination;
